<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Recepciones</h1>
                <div class="caption">
                    Muestra cantidad de recepciones, en el periodo y empresa seleccionada. Permite mostrar el detalle del depósito en el que fue recibido al hacer clic sobre una de las barras
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-menu
                v-model="seriesShow"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
        >
            <v-card raised>
                <v-card-text>
                    <highcharts style="width: 100%" :options="chartSeriesOptions"></highcharts>
                </v-card-text>
            </v-card>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect},
        data() {
            return {
                seriesTit: '',
                seriesShow: false,
                x: 0,
                y: 0,
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD')
                },
                t: {},
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'RECEPCIONES'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    },
                    xAxis: {
                        type: 'category',
                        title: {
                            text: 'Items'
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            },
                            format: '$ {total:,.2f}'
                        },


                    },
                    plotOptions: {
                        column: {
                            stacking: false,
                            grouping: true,
                            dataLabels: {
                                enabled: true,
                                format: '{y}'
                            }
                        },
                        series: {
                            point: {
                                events: {
                                    click: (e) => {
                                        console.log(e);
                                        this.x = e.x;
                                        this.y = e.y;
                                        this.seriesTit = e.point.name;
                                        this.traeSeries(e.point.ano, e.point.mes, e.point.name)
                                    }
                                }
                            }
                        }
                    },
                    series: []
                },
                chartSeriesOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'RECEPCIONES POR DEPOSITO'
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    }
                    ,
                    xAxis: {
                        type: 'category',
                        title:
                            {
                                text: 'Depósitos'
                            }
                    }
                    ,
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        }
                        ,
                        stackLabels: {
                            enabled: true,
                            style:
                                {
                                    fontWeight: 'bold',
                                    color:
                                        'gray'
                                }
                            ,
                            format: '$ {total:,.2f}'
                        }
                        ,
                    }
                    ,
                    plotOptions: {
                        column: {
                            stacking: false,
                            grouping:
                                true,
                            dataLabels:
                                {
                                    enabled: true,
                                    format:
                                        '{y}'
                                }
                        }
                    }
                    ,
                    series: []
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/recepciones', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            },
            traeSeries(ano, mes) {
                this.loading = true;
                this.$http.post('indicadores/recepciones-series', {
                    ano: ano,
                    mes: mes,
                    empresa: this.d.empresa
                })
                    .then(r => {
                        this.chartSeriesOptions.series = r.data;
                        this.chartSeriesOptions.title.text = 'Recepciones por depósito del mes ' + this.seriesTit;
                        this.$nextTick(() => {
                            this.seriesShow = true
                        });
                        this.loading = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/recepciones.vue